import FormSection from './FormSection'
import { translations } from '../../data/translations'
import './FormSection.css'

const OrganizationSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.organization || translations.de.organization

  const handleCheckboxChange = (field, value, checked) => {
    const current = formData[field] || []
    const updated = checked
      ? [...current, value]
      : current.filter(v => v !== value)
    updateFormData(field, updated)
  }

  return (
    <FormSection title={t.title} subtitle={t.subtitle}>
      <h3 className="form-section__subtitle">{t.subtitle1}</h3>
      
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="branche" className="form-group__label">
            {t.branche}
          </label>
          <input
            type="text"
            id="branche"
            name="branche"
            className="form-group__input"
            placeholder={t.branchePlaceholder}
            value={formData.branche || ''}
            onChange={(e) => updateFormData('branche', e.target.value)}
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="dienstleistungen" className="form-group__label">
          {t.dienstleistungen}
        </label>
        <textarea
          id="dienstleistungen"
          name="dienstleistungen"
          className="form-group__input form-group__textarea"
          placeholder={t.dienstleistungenPlaceholder}
          value={formData.dienstleistungen || ''}
          onChange={(e) => updateFormData('dienstleistungen', e.target.value)}
        />
      </div>

      <div className="form-group">
        <label htmlFor="taetigkeitsgebiete" className="form-group__label">
          {t.taetigkeitsgebiete}
        </label>
        <input
          type="text"
          id="taetigkeitsgebiete"
          name="taetigkeitsgebiete"
          className="form-group__input"
          placeholder={t.taetigkeitsgebietePlaceholder}
          value={formData.taetigkeitsgebiete || ''}
          onChange={(e) => updateFormData('taetigkeitsgebiete', e.target.value)}
        />
      </div>

      <h3 className="form-section__subtitle">{t.subtitle2}</h3>

      <div className="form-group">
        <label className="form-group__label">
          {t.zielgruppeTyp} <span className="form-group__required">*</span>
        </label>
        <div className="checkbox-group">
          {t.zielgruppeOptions.map((option) => (
            <label key={option.value} className="radio-group__option">
              <input
                type="checkbox"
                name="zielgruppe_typ[]"
                value={option.value}
                checked={(formData.zielgruppe_typ || []).includes(option.value)}
                onChange={(e) => handleCheckboxChange('zielgruppe_typ', option.value, e.target.checked)}
              />
              <span className="radio-group__label">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="zg_alter" className="form-group__label">
            {t.zg_alter}
          </label>
          <input
            type="text"
            id="zg_alter"
            name="zg_alter"
            className="form-group__input"
            placeholder={t.zg_alterPlaceholder}
            value={formData.zg_alter || ''}
            onChange={(e) => updateFormData('zg_alter', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="zg_standort" className="form-group__label">
            {t.zg_standort}
          </label>
          <input
            type="text"
            id="zg_standort"
            name="zg_standort"
            className="form-group__input"
            placeholder={t.zg_standortPlaceholder}
            value={formData.zg_standort || ''}
            onChange={(e) => updateFormData('zg_standort', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="zg_sprache" className="form-group__label">
            {t.zg_sprache}
          </label>
          <input
            type="text"
            id="zg_sprache"
            name="zg_sprache"
            className="form-group__input"
            placeholder={t.zg_sprachePlaceholder}
            value={formData.zg_sprache || ''}
            onChange={(e) => updateFormData('zg_sprache', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="zg_technik" className="form-group__label">
            {t.zg_technik}
          </label>
          <select
            id="zg_technik"
            name="zg_technik"
            className="form-group__input"
            value={formData.zg_technik || ''}
            onChange={(e) => updateFormData('zg_technik', e.target.value)}
          >
            <option value="">{t.bitteWaehlen}</option>
            {t.zg_technikOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="zg_beduerfnisse" className="form-group__label">
          {t.zg_beduerfnisse}
        </label>
        <textarea
          id="zg_beduerfnisse"
          name="zg_beduerfnisse"
          className="form-group__input form-group__textarea"
          placeholder={t.zg_beduerfnissePlaceholder}
          value={formData.zg_beduerfnisse || ''}
          onChange={(e) => updateFormData('zg_beduerfnisse', e.target.value)}
        />
      </div>

      <h3 className="form-section__subtitle">{t.subtitle3}</h3>

      <div className="form-group">
        <label className="form-group__label">{t.konkurrenz}</label>
        {[1, 2, 3, 4, 5].map((num) => (
          <input
            key={num}
            type="url"
            name={`konkurrenz_${num}`}
            className="form-group__input"
            placeholder={`${num}. https://...`}
            value={formData[`konkurrenz_${num}`] || ''}
            onChange={(e) => updateFormData(`konkurrenz_${num}`, e.target.value)}
            style={{ marginBottom: '8px' }}
          />
        ))}
      </div>

      <div className="form-group">
        <label htmlFor="konkurrenz_analyse" className="form-group__label">
          {t.konkurrenz_analyse}
        </label>
        <textarea
          id="konkurrenz_analyse"
          name="konkurrenz_analyse"
          className="form-group__input form-group__textarea"
          placeholder={t.konkurrenz_analysePlaceholder}
          value={formData.konkurrenz_analyse || ''}
          onChange={(e) => updateFormData('konkurrenz_analyse', e.target.value)}
        />
      </div>
    </FormSection>
  )
}

export default OrganizationSection
